import { OnInit, Input, Output, EventEmitter, Component } from '@angular/core';
import { ViewCell } from 'ng2-smart-table';
import { ColumnsTableModalSelect } from '../models/modal-select.model';
import { find, findIndex } from 'lodash';

@Component({
  selector: 'iw-label-ngselect-dynamic-table',
  template: '<p [innerHtml]="label"></p>',
  styles: ['']
})
export class LabelNgSelectDynamicTableComponent implements ViewCell, OnInit {
  // entrada del valor del label
  @Input() value: any;
  // entrada de la fila
  @Input() rowData: any;
  // label column
  label: any = null;
  // Columnas seleccionadas
  selectionsColumns: string[] = [];
  // Contiene las columans del selector
  columnsLabel: ColumnsTableModalSelect[] = [];
  private columns: ColumnsTableModalSelect[] = [];

  ngOnInit() {
    this.columns = this.getColumns(this.columnsLabel);
    this.loadingColumnsLabel();
  }

  /**
   * Retorna todas las columnas incluyendo las columnas dependientes en un mismo nivel
   *
   * @param {ColumnsTableModalSelect[]} c
   * @returns {ColumnsTableModalSelect[]}
   * @memberof LabelNgSelectDynamicTableComponent
   */
  getColumns(c: ColumnsTableModalSelect[]): ColumnsTableModalSelect[] {
    const cols: ColumnsTableModalSelect[] = [];
    c.forEach(column => {
      if (!column.columnsDependence || !column.columnsDependence.length) {
        cols.push(column);
      } else {
        const cs = this.getColumns(column.columnsDependence);
        if (cs.length) {
          cs.forEach(cl => {
            cols.push(cl);
          });
        }
      }
    });
    return cols;
  }

  /**
   * Cargar label de columna
   *
   * @memberof LabelNgSelectDynamicTableComponent
   */
  loadingColumnsLabel() {
    if (this.columns.length && this.columns.length > 1 && this.value) {
      let labelString = '';
      for (let i = 0; i < this.selectionsColumns.length; i++) {
        const configColum = find(this.columns, {key: this.selectionsColumns[i]});
        const indexConfigColum = findIndex(this.columns, {key: this.selectionsColumns[i]});
        if (configColum) {
          const labels = this.columns[i].label.split(' - ');
          let label = '';
          if (labels.length > 1) {
            label = labels[1];
          } else {
            label = labels[0];
          }
          let element = '<strong>' + label + ': </strong>';
          if (typeof this.value === 'object') {
            if (
              configColum.type !== 'ngSelect' ||
              (
                this.value.hasOwnProperty(configColum.key) &&
                typeof this.value[configColum.key] !== 'object'
              )
            ) {
              if (this.value[configColum.key]) {
                element += this.value[configColum.key] + ' ';
              } else {
                element += 'No aplica ';
              }
            } else {
              const columns = String(configColum.key).split('-');
              if (columns.length && columns.length > 1) {
                let textColumn = '';
                columns.forEach((c, ix) => {
                  if (ix > 0) {
                    textColumn += c;
                    if (ix < (columns.length - 1)) {
                      textColumn += '-';
                    }
                  }
                });
                if (this.value[columns[0]][textColumn]) {
                  element += this.value[columns[0]][textColumn] + ' ';
                } else {
                  element += 'No aplica ';
                }
              } else {
                element += 'No aplica ';
              }
            }
          } else {
            const valueColumns = String(this.value).split('/');
            if (valueColumns.length && indexConfigColum < valueColumns.length) {
              element += valueColumns[indexConfigColum];
            } else {
              element += 'No aplica ';
            }
          }
          if (i > 0) {
            labelString += '/ ' + element;
          } else {
            labelString = element;
          }
        } else {
          if (i > 0) {
            labelString += '/ <strong>Columna</strong> No aplica';
          } else {
            labelString = '<strong>Columna</strong> No aplica';
          }
        }
      }
      const parser = new DOMParser();
      this.label = parser.parseFromString(labelString, 'text/html').body.innerHTML;
    } else {
      if (this.value) {
        if (
          typeof this.value === 'object'
        ) {
          if (this.value.hasOwnProperty(this.selectionsColumns[0])) {
            this.label = this.value[this.selectionsColumns[0]];
          } else {
            this.label = '';
          }
        } else {
          this.label = this.value;
        }
      } else {
        this.label = '';
      }
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/component-table/label-ngSelect-dynamic-table.component.ts